import React from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import { RadioContainer } from './styles';
import { formatDate } from '../../../utils/date';

type TDateRangeRadio = {
  dateStart: string;
  dateEnd: string;
  value: string;
  onChange: (value: string, index: number) => void;
};

const DateRangeRadio: React.FC<TDateRangeRadio> = ({
  dateStart,
  dateEnd,
  value,
  onChange,
}) => {
  const getDatesInRange = (startStr: string, endStr: string): string[] => {
    const startDate = new Date(startStr);
    const endDate = new Date(endStr);
    const dates: string[] = [];

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return dates;
    }

    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      dates.push(currentDate.toISOString().split('T')[0]); // Формат YYYY-MM-DD
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const dates = getDatesInRange(dateStart, dateEnd);

  if (dates.length === 0) {
    return <div>Нет доступных дат</div>;
  }

  const radioOptions = dates.map((date) => ({
    label: formatDate(new Date(date)),
    value: formatDate(new Date(date)),
  }));

  const onChangeRadio = (e: RadioChangeEvent) => {
    const selectedIndex = radioOptions.findIndex(
      (item) => item.value === e.target.value
    );
    onChange(e.target.value, selectedIndex);
  };

  return (
    <RadioContainer>
      <Radio.Group
        optionType='button'
        buttonStyle='solid'
        options={radioOptions}
        value={value || radioOptions[0].value}
        onChange={onChangeRadio}
      />
    </RadioContainer>
  );
};

export default DateRangeRadio;
